export interface Props {
  children?: React.ReactNode;
}

export const Main: React.FC<Props> = ({ children }) => (
  <main className="O-Main">{children}</main>
);
